import { render, staticRenderFns } from "./modal-expiry-reminder.vue?vue&type=template&id=4a8d8e3e&"
import script from "./modal-expiry-reminder.vue?vue&type=script&lang=js&"
export * from "./modal-expiry-reminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports